export default defineNuxtPlugin(() => {
  // Import all page components to prevent error: Failed to fetch dynamically imported module
  import.meta.glob('~/components/page/Page*.vue', { eager: true });

  // TODO: Test performance impact of this plugin
});
